import { watch } from "vue"
import interact from "interactjs"

export const setupPanning = ({ keyboardState, containerState }) => {
  watch(
    keyboardState.isSpaceKeyPressing,
    isSpaceKeyPressing => {
      const containerElement = containerState.element.value
      if (!containerElement) return

      if (isSpaceKeyPressing) {
        // Clear current selection
        const selection = document.getSelection()
        selection.empty()

        containerElement.style.cursor = "grab"

        interact('[data-target="container"]')
          .styleCursor(false)
          .draggable({
            listeners: {
              start: () => {
                containerElement.style.cursor = "grabbing"
              },
              move: event => {
                containerElement.scrollLeft = containerElement.scrollLeft - event.delta.x
                containerElement.scrollTop = containerElement.scrollTop - event.delta.y
              },
              end: () => {
                containerElement.style.cursor = "grab"
              }
            }
          })
      } else {
        containerElement.style.cursor = "auto"
        interact('[data-target="container"]').unset()
      }
    },
    { immediate: true }
  )
}
